import React from 'react';

import { Box, Pagination } from '@mui/material';

import { API } from '@luxuryescapes/lib-types';

import OrderCard from './OrderCard';

interface Props {
  purchases: Array<API.Order.Order>;
  total: number;
  page: number;
  sizePerPage: number;
  onPageChange: (page: number) => void;
}

export default function OrdersCardList({ page, onPageChange, sizePerPage, purchases, total }: Props) {
  const pageCount = Math.ceil(total / sizePerPage);

  return (
    <Box>
      {purchases.map((purchase) => (
        <OrderCard key={purchase.id} order={purchase as unknown as App.Order} />
      ))}

      {pageCount > 1 && (
        <Box display="flex" justifyContent="center" mt={3}>
          <Pagination color="primary" count={pageCount} page={page} onChange={(_, newPage) => onPageChange(newPage)} />
        </Box>
      )}
    </Box>
  );
}
